import React from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { UiGrayCard } from "./UiGrayCard";
import { UiButton, UiTextIconButton } from "./common/UiButton";
import { InfoIcon } from "../../styles/img/svg/InfoIcon";
import { accountConstants, commonConstants } from "../../_redux/_constants";

export const UiAccountCard = (props) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <UiGrayCard>
        <Grid container spacing={2} className="df-acard">
          <Grid size={{ xs: 12, sm: 8, md: 8, lg: 8 }}>
            <div className="df-acard__df-acard-cont">
              <p>{props?.label1}</p>
              <h4>{props?.accountNumber}</h4>
            </div>

            <div className="df-acard__df-acard-cont">
              <p>{props?.label2}</p>
              <h4>{props?.accountBalance}</h4>
            </div>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 4, md: 4, lg: 4 }}
            className="df-acard__df-acard-btn"
          >
            {!props?.isFdCard ? <h4>{props.accountName}</h4> : ""}

            {props?.fdType && (
              <div className="df-fd-account-card-wr df-fd-saving-types">
                <label
                  className={
                    props.fdType === accountConstants.ONLINE_BANKING_CHANNEL
                      ? "df-lbl-pending"
                      : "df-lbl-success"
                  }
                >
                  {props.fdType}
                </label>
              </div>
            )}

            <UiButton name={props?.buttonText} onClick={props?.onClick} />
          </Grid>

          {props?.supplementaryCard && (
            <>
              <Grid
                size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="df-acard__supplimentery-card"
              >
                <UiTextIconButton
                  icon={<InfoIcon />}
                  name={props?.SupplementaryButtonName}
                  onClick={props?.supplementaryOnclick}
                  className="df-primary-underlined-text-icon-btn"
                />
              </Grid>
            </>
          )}
        </Grid>
      </UiGrayCard>
    </>
  );
};
